import { PaddingType } from 'common/types/styleTypes'
import styled, { css } from 'styled-components'

interface FaqUiProps {
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
  spaceBetweenItems: number
}

export const FaqUi = styled.div<FaqUiProps>`
  display: grid;
  grid-gap: ${p => p.spaceBetweenItems}px;
  padding-top: ${p => p.padding?.paddingTop || 0}px;
  padding-right: ${p => p.padding?.paddingRight || 0}px;
  padding-bottom: ${p => p.padding?.paddingBottom || 0}px;
  padding-left: ${p => p.padding?.paddingLeft || 0}px;
  ${p => p.theme.phone} {
    padding-top: ${p => p.mobilePadding?.paddingTop || 0}px;
    padding-right: ${p => p.mobilePadding?.paddingRight || 0}px;
    padding-bottom: ${p => p.mobilePadding?.paddingBottom || 0}px;
    padding-left: ${p => p.mobilePadding?.paddingLeft || 0}px;
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      padding-top: ${p.mobilePadding?.paddingTop || 0}px;
      padding-right: ${p.mobilePadding?.paddingRight || 0}px;
      padding-bottom: ${p.mobilePadding?.paddingBottom || 0}px;
      padding-left: ${p.mobilePadding?.paddingLeft || 0}px;
    `}
`
